import { useCallback, useState } from 'react';
import { useFormContext } from 'react-hook-form';

export interface ToggleOptionalFieldHook {
  visible: boolean;
  onAddClick: () => void;
  onRemoveClick: () => void;
}

export default function useToggleOptionalField(
  fieldName: string,
  initalValue: unknown,
  initiallyVisible: boolean,
): ToggleOptionalFieldHook {
  const { setValue } = useFormContext();

  const [visible, setVisible] = useState<boolean>(initiallyVisible);

  const onAddClick = useCallback(() => {
    setValue(fieldName, initalValue);
    setVisible(true);
  }, [setValue, fieldName, initalValue]);

  const onRemoveClick = useCallback(() => {
    setValue(fieldName, undefined);
    setVisible(false);
  }, [setValue, fieldName]);

  return {
    visible,
    onAddClick,
    onRemoveClick,
  };
}
